import { useEffect, useState, type ReactNode } from "react";
import { useAdminSettings } from "@/hooks/useAdminSettings";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";

const MAX_SETTINGS_WAIT_MS = 750;

export function AdminSettingsGate({ children }: { children: ReactNode }) {
  const { loading } = useAdminSettings();
  const [fallbackReady, setFallbackReady] = useState(false);

  useEffect(() => {
    if (!loading) return;

    const timeoutId = window.setTimeout(() => setFallbackReady(true), MAX_SETTINGS_WAIT_MS);
    return () => window.clearTimeout(timeoutId);
  }, [loading]);

  if (loading && !fallbackReady) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return <>{children}</>;
}
